import i18next from "i18next";

export function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
}

export const replaceFontFamily = (text, family = 'cairo', size = "14px", onlyFamily = false) => {
    const newText = text.replace(/font-family\s*:\s*[a-zA-Z\-,\s]+;/g, `font-family: ${family};`)
        .replace(/background-color:\s*[^;]+;/gi, 'background-color: none;');
    if (!onlyFamily) {
        newText.replace(/font-size:\s*[\d.]+(px|em|%|rem|vh|vw|vmin|vmax|cm|mm|in|pt|pc|ex|ch)/g, `font-size: ${size}`);
    }

    return newText;
};

export const swapArrayLocs = (arr, index1, index2) => {
    const tarr = [...arr];
    const temp = tarr[index1];
    tarr[index1] = tarr[index2];
    tarr[index2] = temp;
    return tarr;
};


export function deleteChoices(choices, correctChoiceId, choicesToDelete) {
    let correctIndex = choices.findIndex(choice => choice.id === correctChoiceId);
    if (correctIndex === -1) {
        return choices;
    }

    let indicesToDelete = [];

    while (indicesToDelete.length < choicesToDelete) {
        let randomIndex = Math.floor(Math.random() * choices.length);
        if (randomIndex !== correctIndex && !indicesToDelete.includes(randomIndex)) {
            indicesToDelete.push(randomIndex);
        }
    }

    indicesToDelete.sort((a, b) => b - a);

    indicesToDelete.forEach(index => {
        choices.splice(index, 1);
    });

    return choices;
}

export const toastOptions = () => {
    const isArabic = i18next.language === 'ar';
    return {
        position: isArabic ? 'bottom-left' : 'bottom-right',
        theme: 'dark',
    };
};

export function getDomPath(el, root) {
    const path = [];
    while (el && el !== root) {
        let index = 0;
        let sibling = el;
        while (sibling.previousSibling) {
            sibling = sibling.previousSibling;
            index++;
        }
        path.unshift(index);
        el = el.parentNode;
    }
    return path.join("/");
}

// Helper to find node by DOM path
export function findNodeByPath(root, path) {
    const parts = path.split("/").map(Number);
    let node = root;
    for (let idx of parts) {
        if (!node || !node.childNodes) return null;
        node = node.childNodes[idx];
    }
    return node;
}


export const getSelectedText = (containerRef) => {
    const selection = window.getSelection();
    if (!selection.rangeCount || selection.isCollapsed) return;

    const range = selection.getRangeAt(0);
    const rect = range.getBoundingClientRect();
    const { startContainer, startOffset, endContainer, endOffset } = range;

    if (selection.toString().trim() === "") return;

    const startPath = getDomPath(startContainer, containerRef.current);
    const endPath = getDomPath(endContainer, containerRef.current);


    const id = Math.random().toString(36).substring(2, 9);
    const selectionData = { data: { id, startPath, startOffset, endPath, endOffset, rect, }, selection };

    return selectionData;
};

export const applyHighlights = (containerRef, highlights, setSelectedHighlight) => {
    if (!containerRef.current || !highlights.length) return;

    highlights.forEach((highlight) => {
        const startNode = findNodeByPath(containerRef.current, highlight.startPath);
        const endNode = findNodeByPath(containerRef.current, highlight.endPath);

        if (!startNode || !endNode) return;
        try {
            const range = document.createRange();
            range.setStart(startNode, highlight.startOffset);
            range.setEnd(endNode, highlight.endOffset);

            const highlightSpan = document.createElement("span");
            highlightSpan.style.backgroundColor = "yellow";
            highlightSpan.style.cursor = "pointer";
            highlightSpan.setAttribute("data-highlighted", "true");
            highlightSpan.addEventListener('click', (e) => {
                e.stopPropagation();
                setSelectedHighlight({ data: { ...highlight }, type: "REMOVE_HIGHLIGHT" });
            });
            range.surroundContents(highlightSpan);
        } catch (err) {

        }
    });
};

export const deleteHighlights = (containerRef) => {
    const highlightedSpans = containerRef.current.querySelectorAll('span[data-highlighted="true"]');
    highlightedSpans.forEach((span) => {
        const parent = span.parentNode;
        while (span.firstChild) {
            parent.insertBefore(span.firstChild, span);
        }
        parent.removeChild(span);
    });
    containerRef.current.normalize(); // Merge adjacent text nodes
};